import {combineReducers} from 'redux';

const initialStateUser = {
  logedIn: false,  
  user: {},
};

export const userReducer = (state = initialStateUser, action) => {
      switch (action.type) {
        case 'SET_USER':
            return {
                ...state,
                logedIn: true,  
                user: action.data
            }
        case 'RESET_USER':
            return {
                ...state,
                logedIn: false,  
                user: {}
            }
        default:
            return state
        }
};

const reducer = combineReducers({
    userReducer,
});

export default reducer;
